export const checkinEditDrawer = {
  header: {
    title: "Edit check-in details",
    age: "Age:",
    docNotRequiredMinor: "Document not required (minor)",
    docOptionalMinorES: "Document optional (minor in Spain)",
    docOptionalMinorCO: "Document optional (under 7 in Colombia)",
  },
  sections: {
    basicData: "Basic details",
    stayDates: "Stay dates",
    italyDoc: "Document and country of birth",
    doc: "Document and nationality",
  },
  fields: {
    firstName: "First name",
    lastName: "Last name",
    email: "Email",
    phone: "Phone",
    birthDate: "Date of birth",
    sex: "Gender",
    checkIn: "Check-in",
    checkOut: "Check-out",
    docType: "Document type",
    docNumber: "Document number",
    supportNumber: "Support number",
    nationality: "Nationality",
  },
  placeholders: {
    select: "Select",
    selectNationality: "Select nationality",
    searchCountry: "Search country...",
    selectCountry: "— select country —",
    docNumberExample: "e.g. AB1234567",
    docNumberGeneric: "DNI / NIE / Passport",
    required: "Required",
    optional: "Optional",
  },
  sex: {
    male: "Male",
    female: "Female",
    preferNotToSay: "Prefer not to say",
    other: "Other",
  },
  italy: {
    badge: "Alloggiati Web",
    birthCountryLabel: "Country of birth",
    birthCountryHint: "— also used as citizenship",
    issuePlaceLabel: "Document place of issue",
    issuePlaceHint: "— country where the document was issued",
    alloggiatiCode: "Alloggiati code:",
    iso3Label: "ISO3:",
    minorNote:
      "Minor — document type, number and place of issue are sent blank to Alloggiati Web (TABELLA 1).",
  },
  hints: {
    docOptional:
      "Document optional by age/country rule. You can still fill it in.",
  },
  docTypes: {
    it: {
      IDENT: "Identity document (IDENT)",
      IDELE: "Electronic identity document (IDELE)",
      PASOR: "Ordinary passport (PASOR)",
      PASSE: "Service passport (PASSE)",
      PASDI: "Diplomatic passport (PASDI)",
      PATEN: "Driving licence (PATEN)",
      PATNA: "Boating licence (PATNA)",
      CIDIP: "Diplomatic ID (CIDIP)",
      RIFUG: "Refugee travel document (RIFUG)",
    },
    co: {
      CC: "Citizenship card",
      CE: "Foreigner ID card",
      P: "Passport",
      PPT: "Temporary Protection Permit",
      PEP: "Special Residence Permit",
      DE: "Foreign document",
      CD: "Diplomatic card",
    },
    es: {
      ID: "DNI",
      IM: "NIE",
      P: "Passport",
      OTRO: "Other",
    },
    generic: {
      ID: "Identity document",
      P: "Passport",
      OTRO: "Other",
    },
  },
  footer: {
    cancel: "Cancel",
    save: "Save",
    saving: "Saving...",
  },
  errors: {
    nameRequired: "First and last name are required.",
    emailInvalid: "Invalid email.",
    phoneRequired: "Phone is required.",
    birthDateRequired: "Date of birth is required.",
    sexRequired: "Gender is required.",
    stayDatesRequired: "Stay dates are required.",
    checkoutBeforeCheckin: "Check-out date cannot be earlier than check-in date.",
    birthCountryRequired: "Country of birth is required.",
    docTypeRequired: "Document type is required.",
    docNumberRequired: "Document number is required.",
    issuePlaceRequired: "Document place of issue is required.",
    nationalityRequired: "Nationality is required.",
    supportNumberRequired:
      "Support number is required for Spanish nationality (adult).",
    saveFailed: "Could not save.",
    saveError: "Error saving changes.",
  },
  toast: {
    saved: "Check-in updated successfully",
  },
};
